import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/index'

import paths from './paths'
import pathsOnlyPayments from './paths-only-payments';
import pathsOnlyYourParking from './paths-only-your-parking';

Vue.use(VueRouter)

const router = new VueRouter({
    routes: store.getters['app/isPrepaidFlow']
      ? pathsOnlyPayments
      : store.getters['app/isTenant']
        ? pathsOnlyYourParking
        : paths,
})

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (store.getters['app/authorized']) {
            next()
            return
        }
        next('/login')
    } else {
        next()
    }
})


export default router
